import getFeData from './util';

export const FETCH_FE_DATA_REQUEST = 'fetchFeDataRequest';
export const FETCH_FE_DATA_SUCCESS = 'fetchFeDataSuccess';
export const FETCH_FE_DATA_ERROR = 'fetchFeDataError';

function fetchRequest() {
  return {
    type: FETCH_FE_DATA_REQUEST
  };
}

function fetchSuccess(userData) {
  return {
    type: FETCH_FE_DATA_SUCCESS,
    payload: userData
  };
}

function fetchError(error) {
  return {
    type: FETCH_FE_DATA_ERROR,
    payload: error
  };
}

export function fetchFeData() {
  return async (dispatch) => {
    try {
      dispatch(fetchRequest());

      const { data: currentFeData } = await getFeData();

      dispatch(fetchSuccess(currentFeData));
    } catch (error) {
      console.error(error);
      dispatch(fetchError(error));
    }
  };
}
